import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'Is this a dedicated self-defense course or Taekwondo?',
  answer: 'We teach self-defense through the framework of adult Taekwondo. You will learn practical self-defense applications while also getting the fitness and structure of a traditional martial art.'
}, {
  question: 'Do I need to be strong or athletic?',
  answer: 'No. Good self-defense relies on leverage, technique, and timing rather than brute strength. Our classes are designed for all body types and fitness levels.'
}, {
  question: 'Will I get hurt?',
  answer: 'Safety is our top priority. We practice techniques in a controlled, cooperative environment. You will not be thrown into aggressive sparring on day one.'
}];
export function SelfDefenseFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2975" />;
}